import { render, staticRenderFns } from "./MessageTab.vue?vue&type=template&id=40c911de&"
import script from "./MessageTab.vue?vue&type=script&lang=js&"
export * from "./MessageTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports